import {
  getCatalogsAPI,
  updateCatalogAPI,
  deleteCatalogAPI,
  createCatalogAPI,
  detailCatalogMenuAPI,
  createCatalogMenuAPI,
  updateCatalogMenuAPI,
  deleteMenuAPI,
  getMenuByIdAPI,
  addMealIntoMenuAPI,
  deleteMealIntoMenuAPI,
} from "app/services/catalogs";
import i18n from "app/config/i18n";
import { alertMessage } from "./common";
import { errorHandler } from "app/shared/Service/errorHandler";
import {
  SET_CATALOG_DATA,
  SET_CATALOG_LOADING,
  SET_CATALOG_TOKENS,
  CLEAR_CATALOG_STORE,
  SET_ACTIVE_CATALOG_ID,
  SET_CATALOG_MENU_LOADING,
  SET_CATALOG_MENU,
  SET_CATALOG_ACTIVE_MENU,
  RESET_MENU_DATA,
  SET_ACTIVE_MENU_ITEMS,
  SET_ACTIVE_MENU_ITEMS_LOADER,
  SET_MEAL_TO_DELETE_LOADER,
  SET_MEAL_TO_DELETE,
  SET_DELETING_ACTIVE_MENU_ITEMS,
} from "app/utils/constants/catalogs";

import { processCatalogMenu } from "app/pages/menus/catalog/helpers/processCatalogMenu";
import { processSelectedMenu } from "app/pages/menus/catalog/helpers/processSelectedMenu";

export const getCatalogs = (payload?: any) => {
  return async (dispatch: any) => {
    try {
      // start loading manually
      dispatch({
        type: SET_CATALOG_LOADING,
        payload: true,
      });

      const { data } = await getCatalogsAPI(payload);

      // placed the data to PRODUCTION_DATA state
      dispatch({
        type: SET_CATALOG_DATA,
        payload: data?.data || null,
      });

      dispatch({
        type: SET_CATALOG_TOKENS,
        payload: {
          nextToken: data?.pagination?.next?.continutationToken || null,
          prevToken: data?.pagination?.previous?.continutationToken || null,
        },
      });

      // before processing reset all related to menu
      dispatch({
        type: RESET_MENU_DATA,
      });

      dispatch({
        type: SET_ACTIVE_CATALOG_ID,
        payload: null,
      });
    } catch (error) {
      const message = errorHandler(error);
      dispatch(alertMessage(message, "error"));
    } finally {
      // when its done turn the loading to False
      dispatch({
        type: SET_CATALOG_LOADING,
        payload: false,
      });
    }
  };
};

export const createCatalog = (
  payload: object,
  cb?: Function,
  errorCb?: Function,
) => {
  return async (dispatch: any) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data } = await createCatalogAPI(payload);
      dispatch(alertMessage(i18n.t("pages.catalog.create.success"), "success"));
      cb?.(data?.data?.id);
    } catch (err) {
      errorCb?.();
      const message = errorHandler(err);
      dispatch(alertMessage(message, "error"));
    }
  };
};

export const updateCatalog = (
  catalogId: number,
  payload: object,
  cb?: Function,
) => {
  return async (dispatch: any) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data } = await updateCatalogAPI(catalogId, payload);
      dispatch(alertMessage(i18n.t("pages.catalog.update.success"), "success"));
      cb?.();
    } catch (err) {
      const message = errorHandler(err);
      dispatch(alertMessage(message, "error"));
    }
  };
};

export const deleteCatalog = (catalogId: number, cb?: Function) => {
  return async (dispatch: any) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data } = await deleteCatalogAPI(catalogId);
      dispatch(alertMessage(i18n.t("pages.catalog.delete.success"), "success"));
      cb?.();
    } catch (err) {
      const message = errorHandler(err);
      dispatch(alertMessage(message, "error"));
    }
  };
};

export const clearCatalogStore = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_CATALOG_STORE,
  });
};

export const getCatalogMenu = (catalogId: number) => {
  return async (dispatch: any) => {
    try {
      // start loading manually
      dispatch({
        type: SET_CATALOG_MENU_LOADING,
        payload: true,
      });

      const {
        data: { data, included },
      } = await detailCatalogMenuAPI(catalogId);

      // before processing reset all related to menu
      dispatch({
        type: RESET_MENU_DATA,
      });

      const finalMenu = processCatalogMenu(data, included);

      dispatch({
        type: SET_CATALOG_MENU,
        payload: finalMenu || null,
      });

      dispatch({
        type: SET_ACTIVE_CATALOG_ID,
        payload: catalogId,
      });

      // get firstmenu
      if (finalMenu.length > 0) {
        const firstMenu = finalMenu[0];
        // set the active catalog menu with the very first one
        dispatch({
          type: SET_CATALOG_ACTIVE_MENU,
          payload: firstMenu,
        });

        // after menu was returned we need to request the items as well
        dispatch(getMenuById(catalogId, firstMenu.id));
      }
    } catch (error) {
      const message = errorHandler(error);
      dispatch(alertMessage(message, "error"));
    } finally {
      // when its done turn the loading to False
      dispatch({
        type: SET_CATALOG_MENU_LOADING,
        payload: false,
      });
    }
  };
};

export const createCatalogMenu = (
  catalogId: number,
  payload: object,
  cb?: Function,
  errorCb?: Function,
) => {
  return async (dispatch: any) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data } = await createCatalogMenuAPI(catalogId, payload);
      dispatch(alertMessage(i18n.t("pages.menu.create.success"), "success"));
      cb?.();
    } catch (err) {
      errorCb?.();
      const message = errorHandler(err);
      dispatch(alertMessage(message, "error"));
    }
  };
};

export const updateCatalogMenu = (
  catalogId: number,
  payload: object,
  menuId: number,
  cb?: Function,
  errorCb?: Function,
) => {
  return async (dispatch: any) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data } = await updateCatalogMenuAPI(catalogId, payload, menuId);
      dispatch(alertMessage(i18n.t("pages.menu.update.success"), "success"));
      cb?.();
    } catch (err) {
      errorCb?.();
      const message = errorHandler(err);
      dispatch(alertMessage(message, "error"));
    }
  };
};

export const deleteMenu = (
  menuId: number,
  catalogId: number,
  cb?: Function,
) => {
  return async (dispatch: any) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data } = await deleteMenuAPI(menuId, catalogId);
      dispatch(alertMessage(i18n.t("pages.menu.delete.success"), "success"));
      cb?.();
    } catch (err) {
      const message = errorHandler(err);
      dispatch(alertMessage(message, "error"));
    }
  };
};

export const getMenuById = (catalogId: number, menuId: number) => {
  return async (dispatch: any) => {
    try {
      // start loading manually
      dispatch({
        type: SET_ACTIVE_MENU_ITEMS_LOADER,
        payload: true,
      });

      const { data } = await getMenuByIdAPI(catalogId, menuId);

      const finalData = processSelectedMenu(data);

      // placed the data to PRODUCTION_DATA state
      dispatch({
        type: SET_ACTIVE_MENU_ITEMS,
        payload: finalData,
      });
    } catch (error) {
      const message = errorHandler(error);
      dispatch(alertMessage(message, "error"));
    } finally {
      // when its done turn the loading to False
      dispatch({
        type: SET_ACTIVE_MENU_ITEMS_LOADER,
        payload: false,
      });
    }
  };
};

export const addMealIntoMenu = (
  catalogId: number,
  menuId: number,
  payload: object,
  cb?: Function,
  errorCb?: Function,
) => {
  return async (dispatch: any) => {
    try {
      const { data } = await addMealIntoMenuAPI(catalogId, menuId, payload);
      dispatch(alertMessage(i18n.t("pages.meal.create.success"), "success"));
      cb?.(data?.data?.id);
    } catch (err) {
      errorCb?.();
      const message = errorHandler(err);
      dispatch(alertMessage(message, "error"));
    }
  };
};

export const deleteMealIntoMenu = (
  catalogId: number,
  menuId: number,
  meals: any,
) => {
  return async (dispatch: any) => {
    try {
      // start loading manually
      dispatch({
        type: SET_MEAL_TO_DELETE_LOADER,
        payload: true,
      });

      for (const item of meals) {
        await deleteMealIntoMenuAPI(
          catalogId,
          menuId,
          item.name,
          item.class,
          item.dishId,
        );
      }

      // reset mealToDelete
      dispatch({
        type: SET_MEAL_TO_DELETE,
        payload: [],
      });

      dispatch({
        type: SET_DELETING_ACTIVE_MENU_ITEMS,
        payload: false,
      });

      dispatch(getMenuById(catalogId, menuId));
    } catch (error) {
      const message = errorHandler(error);
      dispatch(alertMessage(message, "error"));
    } finally {
      // when its done turn the loading to False
      dispatch({
        type: SET_MEAL_TO_DELETE_LOADER,
        payload: false,
      });
    }
  };
};
